import { useWizard } from "../wizard-state";
import type { YesNo } from "@/types/wizard";

const yesNoOptions: { value: YesNo; label: string }[] = [
  { value: "si", label: "Sí" },
  { value: "no", label: "No" },
];

function YesNoSelect({
  label,
  value,
  onChange,
  className,
}: {
  label: string;
  value: YesNo;
  onChange: (v: YesNo) => void;
  className?: string;
}) {
  return (
    <label className="form-field">
      <span>{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value as YesNo)} className={className}>
        {yesNoOptions.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </label>
  );
}

export function Step2Administrativo() {
  const { data, set } = useWizard();

  return (
    <div className="wizard-section-group">
      <div className="wizard-section">
        <h4 className="wizard-section-title">Documentos y trámites</h4>
        <div className="wizard-grid">
          <YesNoSelect label="Orden médica vigente"       value={data.orden}         onChange={(v) => set("orden", v)} />
          <YesNoSelect label="Copago pagado"              value={data.copago}        onChange={(v) => set("copago", v)} />
          <YesNoSelect label="Insumo disponible"          value={data.insumo}        onChange={(v) => set("insumo", v)} />
          <YesNoSelect label="Procedimiento autorizado"   value={data.autorizacion}  onChange={(v) => set("autorizacion", v)} />
        </div>

        <label className="form-field form-field--full mt-8">
          <span>Insumos especiales (detalle)</span>
          <textarea
            rows={2}
            value={data.insumoDetalle}
            onChange={(e) => set("insumoDetalle", e.target.value)}
            placeholder="Describe insumos especiales, referencias, lote, condiciones — o deja vacío si no aplica."
          />
        </label>
      </div>

      <div className="wizard-section">
        <h4 className="wizard-section-title">Condiciones del paciente</h4>
        <div className="wizard-grid">
          <YesNoSelect label="Acompañante responsable"       value={data.acompanante}         onChange={(v) => set("acompanante", v)} />
          <YesNoSelect label="Ayuno cumplido"                value={data.ayuno}               onChange={(v) => set("ayuno", v)} />
          <YesNoSelect label="Confirmó suspensión medicamentos" value={data.suspensionMedConfirm} onChange={(v) => set("suspensionMedConfirm", v)} />
          <YesNoSelect label="Disponibilidad postoperatorio" value={data.dispPostop}          onChange={(v) => set("dispPostop", v)} />
        </div>

        <div className="wizard-checkboxes mt-8">
          <label>
            <input
              type="checkbox"
              checked={data.esMenorEdad}
              onChange={(e) => set("esMenorEdad", e.target.checked)}
            />
            El paciente es menor de edad
          </label>
        </div>

        {(data.esMenorEdad || data.acompanante === "si") && (
          <label className="form-field form-field--full mt-8">
            <span>
              Nombre y parentesco del acompañante
              {data.esMenorEdad && " *"}
            </span>
            <input
              value={data.nombreAcompanante}
              onChange={(e) => set("nombreAcompanante", e.target.value)}
              placeholder="Ej. Juan Pérez (padre) — obligatorio si es menor de edad"
              className={data.esMenorEdad && !data.nombreAcompanante.trim() ? "campo-requerido-error" : ""}
            />
          </label>
        )}

        <div className="wizard-checkboxes mt-8">
          <label>
            <input
              type="checkbox"
              checked={data.recMedAntihipertensivos}
              onChange={(e) => set("recMedAntihipertensivos", e.target.checked)}
            />
            Recibió medicamentos antihipertensivos hoy
          </label>
          <label>
            <input
              type="checkbox"
              checked={data.recMedTiroidea}
              onChange={(e) => set("recMedTiroidea", e.target.checked)}
            />
            Recibió medicamento tiroideo hoy
          </label>
        </div>
      </div>

      <div className="wizard-section">
        <h4 className="wizard-section-title">Modalidad y orientación</h4>
        <div className="wizard-grid">
          <label className="form-field">
            <span>Modalidad</span>
            <select value={data.modalidad} onChange={(e) => set("modalidad", e.target.value as "presencial" | "virtual")}>
              <option value="presencial">Presencial</option>
              <option value="virtual">Virtual</option>
            </select>
          </label>
          <YesNoSelect label="Comprende el procedimiento"      value={data.orientComprende}    onChange={(v) => set("orientComprende", v)} />
          <YesNoSelect label="Conoce hora y fecha"             value={data.orientHoraAntic}    onChange={(v) => set("orientHoraAntic", v)} />
          <YesNoSelect label="Conoce signos de alarma"         value={data.orientSignosAlarma} onChange={(v) => set("orientSignosAlarma", v)} />
        </div>
      </div>
    </div>
  );
}
